<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Registra y controla pagos de clientes. 
                Permite ingresar cobros, aplicar abonos a facturas y 
                ver saldos pendientes. Úsalo para mantener al día las 
                cuentas y evitar moras.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Cobranza
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Visualiza, exporta y genera los estados de las <b>cobranzas</b> realizadas y aprobadas por los <b>socios de negocio</b>.
        </div>
      </div>
      <!-- Header -->
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex shrink-0">
              <!-- Title -->
              <!--<div class="text-3xl font-extrabold tracking-tight">Cambios de Productos</div> -->
              <app-status-filters [selectedStatuses]="selectedStatuses" [selectedERPStatuses]="selectedERPStatuses"
                [showStatus]="[0,6,7,8]" [showERPStatus]="[4,1,0,3]" [typeFilter]="'Charges'" (selectionFilterApply)="findAllWithCount()">
              </app-status-filters> 
          </div>
          <!-- Actions -->
          <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
            <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
              <span class="ml-2">Exportar</span>
            </button>
          </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <div class="pt-1 mx-6">
        <app-smart-grid
          [data]="data"
          [columnDefs]="columnDefs"
          [config]="gridConfig"
          [loading]="isLoading"
          [totalRecords]="totalItems"
          (pageChanged)="onPageChange($event)"
          (sortChanged)="onSortChange($event)">
        </app-smart-grid>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="findAllWithCount()"
    (onCleanEvent)="onClearFilter()"
  >
    <app-filter-section title="Rango de Fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true"/>
    </app-filter-section>

    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
      <app-configuration-filters
        [form]="form"
        [companyWithMongoId]="true"
        [loadData]="loadConfigData"
      ></app-configuration-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de Rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters
          [form]="form"
          [route]="true"
          [loadData]="loadRoutesData"
        ></app-routes-filters>
    </app-filter-section>

    <app-filter-section title="Socios de Negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters
        [form]="form"
        [businessPartner]="true"
        [loadData]="loadBusinessPartnersData"
      ></app-business-partners-filters>
    </app-filter-section>

    <app-filter-section title="Finanzas" [expanded]="false" (onExpanded)="onFinanceExpanded()">
      <app-finance-filters
        [form]="form"
        [paymentMethodList]="paymentMethodFilterList"
        [paymentTypeList]="paymentTypeList"
        [bankList]="bankList"
      ></app-finance-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>